import * as PIXI from "pixi.js";
import Layers from "../../../layers/Layers";
import CompassRendererFactory from "./CompassRendererFactory";
import { Coord } from "../../../types/Interface";
import calcKnobCoord from "./helpers/calcKnobCoord";


export default class CompassRenderer extends PIXI.Container {
  public Layers = Layers.getInstance();
  public lock = this.addChild(new PIXI.Graphics());
  public needleLeg = this.addChild(new PIXI.Graphics());
  public pencil = this.addChild(new PIXI.Graphics());
  public pencilLeg = this.addChild(new PIXI.Graphics());
  public knob = this.addChild(new PIXI.Graphics());
  public isLockActive: boolean = false;
  public isLockActiveTmprary: boolean = false;
  private startCoord: Coord = { x: 0, y: 0 }
  private endCoord: Coord = { x: 0, y: 0 }
  private pencilColor: number = 0x000000;

  constructor(private totalH: number) {
    super();

    this.addToLayer();
  }
  private addToLayer = () => this.Layers.UITop.addChild(this);
  clearAll = () => [this.knob, this.needleLeg, this.pencilLeg, this.pencil, this.lock].forEach(e => e.clear());
  public setPencilColor = (color: number) => this.pencilColor = color;

  draw(startCoord?: Coord, endCoord?: Coord) {
    startCoord ? this.startCoord = startCoord : "";
    endCoord ? this.endCoord = endCoord : "";
    const knobCoord = calcKnobCoord(this.startCoord, this.endCoord, this.totalH);
    CompassRendererFactory.drawKnob(this.knob, knobCoord, this.startCoord, this.endCoord);
    CompassRendererFactory.drawNeedleLeg(this.needleLeg, this.startCoord, knobCoord, this.totalH);
    CompassRendererFactory.drawPencilLeg(this.pencilLeg, knobCoord, this.endCoord, this.totalH);
    CompassRendererFactory.drawPencil(this.pencil, this.pencilColor, knobCoord, this.endCoord);
    CompassRendererFactory.drawLock(this.lock, this.startCoord, knobCoord, this.endCoord, this.isLockActiveTmprary || this.isLockActive);
  }
}